export default {
  cn: {
    header: {
      hello: '你好',
      userName: '欢迎使用销售后台',
      language: '简体中文',
      adminSuperuser: {
        text: '管理超级用户',
        list: {
          logOut: '登出'
        }
      }
    }
  },
  hk: {
    header: {
      hello: '你好',
      userName: '歡迎使用銷售後臺',
      language: '繁體中文',
      adminSuperuser: {
        text: '管理超級用戶',
        list: {
          logOut: '登出'
        }
      }
    }
  },
  en: {
    header: {
      hello: 'Hello',
      userName: 'Welcome to SPBO',
      language: 'English',
      adminSuperuser: {
        text: 'adminSuperuser',
        list: {
          logOut: 'logOut'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/header.js